import { EvaluationStatus } from 'src/app/common/enums/policy-initiative/evaluation-status.enum'
import { Field } from '../../../../abacus/interfaces/field.interface'
import { PolicyInitiativeCreateEditComponent } from '../policy-initiative-create-edit.component'

const fieldsThatDependOnEvaluationStatus: string[] = [
  'evaluationBy',
  'isEvaluationResultsPubliclyAvailable',
  'evaluationUrls',
  'evaluationFiles',
  'evaluationDescription'
]

export const showIsEvaluatedFields = async (
  context: PolicyInitiativeCreateEditComponent
) => {
  await context.showFields(fieldsThatDependOnEvaluationStatus)
}

export const hideIsEvaluatedFields = async (
  context: PolicyInitiativeCreateEditComponent
) => {
  await context.hideAndEmptyFields(fieldsThatDependOnEvaluationStatus)
}

export const setStep2ConditionalForm = async (
  context: PolicyInitiativeCreateEditComponent,
  item: any
) => {
  const isEvaluatedField: Field = context.fields.find(
    (field) => field.property === 'isEvaluated'
  )

  if (
    item.isEvaluated === EvaluationStatus.Yes ||
    item.isEvaluated === EvaluationStatus.NotYet
  ) {
    await showIsEvaluatedFields(context)
  } else if (
    item.isEvaluated === EvaluationStatus.No ||
    item.isEvaluated === EvaluationStatus.DontKnow
  ) {
    await hideIsEvaluatedFields(context)
  }

  // Set the value, preserving null if it's null

  context.setFieldValue(
    isEvaluatedField,
    item.isEvaluated === null ? null : item.isEvaluated
  )
}
